<template>
	<v-layout row wrap style="page-break-inside: avoid">
		<v-flex d-flex xs1>
			<v-card :color="parseColorValue(colors[0])" class="financial-table-header-color">
				<v-card-text class="text-xs-center"><strong>{{text1}}</strong></v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs5>
			<v-card :color="parseColorValue(colors[1])" class="financial-table-header-color">
				<v-card-text style="text-align: center"><strong>{{text2}}</strong></v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card :color="parseColorValue(colors[2])" class="financial-table-header-color">
				<v-card-text style="text-align: center"><strong>{{text3}}</strong></v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card :color="parseColorValue(colors[3])" class="financial-table-header-color">
				<v-card-text style="text-align: center"><strong>{{text4}}</strong></v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: "finalReportDataRow",

		methods: {
			parseColorValue(val) {
				if (val < 0) {
					return "grey darken-" + (-val);
				}
				return "grey lighten-" + val;
			},
		},

		props: {
			text1: {},
			text2: {},
			text3: {},
			text4: {},
			colors: {},
		},
	};
</script>